const filialKppControlDigits = [
    // Регистрация филиала российской организации
    '02',
    '03',
    '43',
    // Регистрация представительства российской организации
    '04',
    '05',
    '44',
    // Сообщение об открытии обособленного подразделения российской организации
    '31',
    '32',
    '45',
    // Коды 02, 03, 04, 05, 31, 32 сейчас не присваиваются, но КПП с этими кодами, присвоенные ранее, остаются действительными
];

/**
 * Определение является ли организация филиалом по коду КПП
 * @param kpp
 */
export const checkIsFilial = (kpp: string) => {
    if (kpp.length < 6) {
        return false;
    }
    const controlDigits = kpp.slice(4, 6);
    return filialKppControlDigits.includes(controlDigits);
};
